import React from "react";
import { Card, CardContent, Typography, Box, Button, Rating } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CourseCard = ({ course }) => {
    const navigate = useNavigate();
    
    return (
        <Card
            sx={{
                maxWidth: 345,
                borderRadius: 3,
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
        >
            {/* Course Image */}
            <img src={course.image} alt={course.title} style={{ width: "100%", height: 150, width: 150, objectFit: "cover" }} />

            <CardContent>
                {/* Course Title */}
                <Typography sx={{ fontSize: "1.1rem", textAlign: 'left', mb: 1 }} fontWeight="bold">
                    {course.title}
                </Typography>

                {/* Ratings */}
                <Box display="flex" alignItems="left">
                    <Typography sx={{  fontSize: "0.8rem", color: "gray" }}>
                        Ratings
                    </Typography>
                    <Rating value={course.rating} sx={{  ml: 1, mt: 0.5, fontSize: "0.8rem" }} readOnly precision={0.1} />
                    <Typography sx={{ ml: 1, fontSize: "0.8rem", color: "gray" }}>
                        ({course.reviews}+)
                    </Typography>
                </Box>

                {/* Duration & Hours */}
                <Typography  sx={{ fontSize: "0.8rem", textAlign: 'left', mt: 0.5 }}>
                    📅 {course.duration} &nbsp; ⏳ {course.hours} Hours
                </Typography>

                {/* Batch Start Date */}
                <Typography
                    sx={{
                        background: course.batch === "Started" ? "red" : "#ff4444",
                        color: "white",
                        display: "inline-block",
                        padding: "4px 10px",
                        borderRadius: 2,
                        fontSize: "0.85rem",
                        mt: 1,
                        justifyContent: 'left'
                    }}
                >
                    {course.batch === "Started" ? "Batch: Started" : `Starting: ${course.batch}`}
                </Typography>

                {/* Fees */}
                <Typography sx={{ fontSize: "0.8rem", fontWeight: "bold", color: "#28a745", mt: 1, textAlign: 'left' }}>
                    Total Fees: ₹{course.fees}
                </Typography>

                {/* Enroll Button */}
                <Button
                    fullWidth
                    variant="contained"
                    sx={{
                        mt: 2,
                        background: "#6A0DAD",
                        "&:hover": { background: "#4a087a" },
                    }}
                    onClick={() => navigate(`/course/${course.id}`)}
                >
                    Enroll Now
                </Button>
            </CardContent>
        </Card>
    );
};

export default CourseCard;
